const translations = {
    email: 'Email',
    role: 'Role'
};

export default translations;
